import styled from '@emotion/styled';

export const Delimiter = styled.div(({ theme }) => ({
  height: 0.5,
  background: theme.colors.container.primary,
  width: '100%',
}));
